import {InjectionToken} from '@angular/core';

export const WS_SERVER_URL = new InjectionToken<string>('WS_SERVER_URL');
export const WS_BASE_URL = new InjectionToken<string>('WS_BASE_URL');
export const WS_SERVICE_ENDPOINT = new InjectionToken<string>('WS_SERVICE_ENDPOINT');
export const WS_SERVICE_ENDPOINT_URL = new InjectionToken<string>('WS_SERVICE_ENDPOINT_URL');

export const WS_SERVICE_VERSION_DEFAULT = new InjectionToken<string>('WS_SERVICE_VERSION_DEFAULT');
export const WS_SERVICE_VERSION_DEFAULT_URL = new InjectionToken<string>('WS_SERVICE_VERSION_DEFAULT_URL');

export const WS_SERVICE_SCOPE_DEFAULT = new InjectionToken<string>('WS_SERVICE_SCOPE_DEFAULT');
export const WS_SERVICE_SCOPE_DEFAULT_VALUE = new InjectionToken<string>('WS_SERVICE_SCOPE_DEFAULT_VALUE');

export const ENABLE_MANUAL_FEEDBACK = new InjectionToken<string>('ENABLE_MANUAL_FEEDBACK');
export const ENABLE_MANUAL_FEEDBACK_VALUE = new InjectionToken<string>('ENABLE_MANUAL_FEEDBACK');

export const GEOSERVER_URL = new InjectionToken<string>('GEOSERVER_URL');

export const DATEFORMAT_CULTURE = new InjectionToken<string>('DATEFORMAT_CULTURE');
